@if (displayStep()) {
  <div class="status step-container" [ngClass]="status$ | async">
    <pr-treatment-scope-list
      class="block"
      [expanded]="expanded"
      [disabled]="isComplete$ | async"
      [treatments]="treatments$ | async"
      [step]="step$ | async"
      [plan]="plan$ | async"
      [appointment]="appointment$ | async"
      (treatmentsChange)="updateTreatments($event)"
      (treatmentDeleted)="deleteTreatment($event)"
      (updateChartable)="updateChartable.emit($event)"
      (categoryChanged)="updateStepDisplayOverride($event)"
    >
      <pr-treatment-step-header
        scopeListHeader
        [step]="step$ | async"
        [plan]="plan$ | async"
        [status]="status$ | async"
        [appointment]="appointment$ | async"
        [inlcudeMultiTreatments]="inlcudeMultiTreatments"
        [hideDelete]="hideDelete"
        [hideDepositNotification]="hideDepositNotification"
        (stepDeleted)="stepDeleted.emit($event)"
        (stepDisplayChange)="stepChanged.emit({ display: $event })"
      >
        <button
          type="button"
          mat-icon-button
          [matTooltip]="
            expanded ? 'Minimise All Treatments' : 'Expand All Treatments'
          "
          (click)="expanded = !expanded"
        >
          <mat-icon
            [textContent]="expanded ? 'unfold_less' : 'unfold_more'"
          ></mat-icon>
        </button>
      </pr-treatment-step-header>

      <div scopeListFooter>
        @if (isIncomplete$ | async) {
          @if (hasSelection$ | async) {
            <button
              type="button"
              mat-button
              class="action-button"
              (click)="moveTreatmentsHere.emit()"
            >
              <mat-icon>add</mat-icon>
              <span class="text-xs">Move Treatments Here</span>
            </button>
          } @else {
            <pr-add-charted-treatment-button
              [inlcudeMultiTreatments]="inlcudeMultiTreatments"
              (addChartable)="
                addChartable($event.chartable, $event.selectedSurfaces)
              "
            />
          }
        }
      </div>
    </pr-treatment-scope-list>
  </div>
}
